<template>
  <div class="col-12 mg-t-20" v-if="is_strategy">
    <div class="card card-dashboard-nineteen">
      <div class="card-header">
        <h6 class="card-title" style="text-transform: none;color:#1c273c">Asset Strategy Tracking</h6>

        <div class="row">
          <div class="col-6 col-md-5">
            <a
              href="#"
              @click.prevent="getReport(report5, 'AssetStrategy')"
              :class="{ 'is-loading': loadingReport === 'AssetStrategy' }"
            >
              <p class="tx-10">
                Asset Strategy Comparison Report
                <i :class="loadingReport === 'AssetStrategy' ? 'el-icon-loading' : 'el-icon-download'"></i>
              </p>
            </a>
          </div>

          <div class="col-6 col-md-5">
            <a
              href="#"
              @click.prevent="getReport(report6, 'InvestmentAllocation')"
              :class="{ 'is-loading': loadingReport === 'InvestmentAllocation' }"
            >
              <p class="tx-10">
                Detailed Investment Allocation
                <i :class="loadingReport === 'InvestmentAllocation' ? 'el-icon-loading' : 'el-icon-download'"></i>
              </p>
            </a>
          </div>
        </div>

        <div class="chart-legend">
          <div>Actual Allocation</div>
          <div>Target</div>
          <div>Min</div>
          <div>Max</div>
        </div>
      </div>

      <div class="card-body">
        <ChartStrategy
          ref="chart"
          :categories="strategy.categories"
          :actuals="strategy.actuals"
          :maxs="strategy.maxs"
          :mins="strategy.mins"
          :targets="strategy.targets"
          :alerts="strategy.alerts"
        />
      </div>
    </div>
  </div>
</template>

<script>

import ChartStrategy from '../charts/ChartStrategy.vue'
import { downloadReport } from '@/utils/classReports';

export default {
  name: 'strategy',
  components: { ChartStrategy },
  data() {
    return {
      is_strategy: false,
      strategy: {},
      report5: this.$route.params.fund_code + '+AssetStrategy',
      report6: this.$route.params.fund_code + '+InvestmentAllocation',
      loadingReport: null, // 'AssetStrategy' | 'InvestmentAllocation' | null
    };
  },
  created() {
    this.checkStrategy();
  },
  methods: {
    async getReport(report, code) {
      if (this.loadingReport) return;           // prevent parallel clicks
      this.loadingReport = code;                // show spinner for this item
      try {
        await downloadReport({
          report,
          api: this.$api.funddashboard_api,
          fallbackName: 'report.pdf',
        });
      } catch (err) {
        console.error('Failed to fetch or display report:', err);
      } finally {
        this.loadingReport = null;              // restore icon
      }
    },
    checkStrategy() {
      this.$api.funddashboard_api.strategy(this.$route.params.fund_code).then(response => {
        if (response.data === 'No strategy Available') {
          this.is_strategy = false;
        } else {
          this.is_strategy = true;
          this.strategy = response.data;
          if (this.strategy.alerts.length > 0) {
            this.showAlert();
          }
        }
      });
    },
    showAlert() {
      this.$notify({
        title: 'Alert - Asset Strategy',
        message: 'Some Assets are outside the maximum asset percentages.',
        type: 'warning',
        duration: 4500
      });
    },
  }
};
</script>

<style>
/* optional: visually indicate "loading" link state */
.is-loading {
  pointer-events: none;
  opacity: .7;
}
.el-notification .el-icon-warning {
  color: #dc3545;
}
</style>
